var _path, _rect, _rect2, _rect3, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtSubmitProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 130,
    viewBox: "0 0 230 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 12C118 5.37258 123.373 0 130 0H177C183.627 0 189 5.37258 189 12V59C189 65.6274 183.627 71 177 71H118V12Z",
    fill: "#77DDFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 90,
    width: 62,
    height: 8,
    fill: "#C9FEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 106,
    width: 88,
    height: 8,
    fill: "#C9FEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 122,
    width: 36,
    height: 8,
    fill: "#C9FEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.735 40.1623C155.633 40.6437 155.566 41.2971 155.566 42.1568H151.163V40.8157C151.163 39.3714 151.536 38.271 152.044 37.3769C152.518 36.5172 153.331 35.7263 154.347 34.901C154.454 34.8146 154.565 34.727 154.678 34.6378C155.78 33.7673 157.09 32.7337 157.09 31.0495C157.09 29.055 155.769 27.8171 153.635 27.8171C151.265 27.8171 149.91 29.5021 149.606 32.1155L145 31.8404C145.237 27.1981 148.691 24 153.432 24C157.936 24 162 26.4759 162 30.8432C162 33.7662 160.476 35.4856 158.106 37.2393C157.124 37.9615 155.938 39.2338 155.735 40.1623ZM155.904 44.0138V49H150.926V44.0138H155.904Z",
    fill: "#0F214F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 65,
    r: 64.5,
    stroke: "#0F214F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 83C0 76.3726 5.37258 71 12 71H118V118C118 124.627 112.627 130 106 130H12C5.37259 130 0 124.627 0 118V83Z",
    fill: "#0F214F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9168 95.3102L65.8817 92.167L55.8174 102.589L51.1187 97.7234L48.0835 100.867L55.8174 108.834L68.9168 95.3102Z",
    fill: "#EBF7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtSubmitProposal);
export default __webpack_public_path__ + "static/media/art-submit-proposal.ca69a84e18786a49721a759c70bdd81d.svg";
export { ForwardRef as ReactComponent };